import { Button, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import TabsHeader from "../../../../Components/Shared/TabsHeader";
import ContactPartial from "../../../../Components/ContactPhoneFinep/ContactPartial";
import { useContext, useState } from "react";
import { CompanyFinepContext } from "../../../../Contexts/CompanyFinepContext";
import Loader from "../../../../Components/Shared/Loader";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../../Hooks/useAuth";
import { ValidateContactFinep } from "../../../../API/OfficialContactAPI";

const { Title, Text } = Typography;

const ContactPhoneFinepTab = () => {
    const { companyId, registerId } = useParams();
    const user = useAuth();
    const [loading, setLoading] = useState(false);
    const [validateField, setValidateField] = useState(false);
    const { changeTab, handleValidateTab, handleInvalidateTab } = useContext(CompanyFinepContext);

    async function handleValidate(isValid: boolean) {
        setLoading(true);
        setValidateField(isValid);

        await ValidateContactFinep({
            companyFINEPId: companyId ?? "",
            isContentValid: isValid,
            userEmail: user.userEmail
        }).then(() => {
            if (isValid)
                handleValidateTab(2, 2);
            else
                handleInvalidateTab(2, 2);

        }).catch(() => setLoading(false));

        setLoading(false);
    }

    return (
        <>
            {loading && <Loader />}
            <TabsHeader
                canValidate={true}
                valueSelected={validateField}
                changeValidate={handleValidate}
                registerId={registerId}
                cardName=""
                tabName=""
            />
            <Title level={4} style={{ color: '#000085', fontSize: '20px', fontWeight: 'normal' }}>Contato oficial da pessoa jurídica com a FINEP</Title>
            <p className="gray">Informações primárias da empresa</p>
            <ContactPartial setValidateField={setValidateField} type="officialContact" />
            <p className="d-block mt-4 mb-4">Contato da pessoa responsável pela área financeira</p>
            <ContactPartial setValidateField={setValidateField} type="financialContact" />
            <div className="d-flex justify-content-end mt-4 mb-4">
                <Button variant="outlined" className="me-4" onClick={() => changeTab(1)} >Voltar</Button>
                <Button type="primary" htmlType="submit" onClick={() => changeTab(3)}><PlusOutlined /> Próxima Etapa</Button>
            </div>
        </>
    )
};

export default ContactPhoneFinepTab